import { useEffect, useState } from 'react';
import { fetchHasUnread, fetchNotifications, postNotificationsRead } from '@/services/notificationService';

export const useNotifications = () => {
  const [hasUnread, setHasUnread] = useState(false);
  const [notifications, setNotifications] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const unread = await fetchHasUnread();
        if (!cancelled) setHasUnread(unread);
      }
      catch (e) {
        if (!cancelled) setError(e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const loadNotifications = async () => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    try {
      const data = await fetchNotifications();
      if (!cancelled) setNotifications(data);
    }
    catch (e) {
      if (!cancelled) {
        setError(e);
        setNotifications([]);
      }
    }
    finally {
      if (!cancelled) setLoading(false);
    }
    return () => {
      cancelled = true;
    };
  };

  const markAsRead = async () => {
    try {
      await postNotificationsRead();
      setHasUnread(false);
    }
    catch (e) {
      setError(e);
    }
  };

  return { hasUnread, notifications, loading, error, loadNotifications, markAsRead };
};
